<div class="container">
    <div class="d-flex justify-content-center align-items-center custom-my-10">
        <h3 class="text-center v5-blue">{{"There is no data" | translator}}<img class="no-data-img" src="../../assets/icones-2025/emergency_home.png" alt="loading"/></h3>
    </div>
</div>
